// app/modules/auth/auth.routes.ts

import { Route } from '@angular/router';
import { LayoutComponent } from 'app/layout/layout.component';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';

export const authRoutes: Route[] = [
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: 'confirmation-required',
                loadChildren: () =>
                    import(
                        './pages/confirmation-required/confirmation-required.routes'
                    ),
            },
            {
                path: 'forgot-password',
                loadChildren: () =>
                    import('./pages/forgot-password/forgot-password.routes'),
            },
            {
                path: 'reset-password',
                loadChildren: () =>
                    import('./pages/reset-password/reset-password.routes'),
            },
            {
                path: 'sign-in',
                loadChildren: () => import('./pages/sign-in/sign-in.routes'),
            },
            // {
            //     path: 'sign-up',
            //     loadChildren: () => import('./pages/sign-up/sign-up.routes'),
            // },
        ],
    },
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: 'sign-out',
                loadChildren: () => import('./pages/sign-out/sign-out.routes'),
            },
        ],
    },
];
